import React from 'react';
import PropTypes from 'prop-types';

import { Button, Typo, Modal } from '@ers/ui';

const Step2 = ({ onClick }) => (
    <>
        <Typo.Body className="with-margin--bottom-3">
            Dziękujemy za zainteresowanie funkcją samodzielnego dodawania aplikacji, która nie jest jeszcze gotowa.
        </Typo.Body>
        <Typo.Body className="with-margin--bottom-3">
            Na razie chcieliśmy dowiedzieć się od Ciebie tylko czy taka funkcja pomogłaby Ci w poszukiwaniu swojej wymarzonej pracy.
            Teraz już wiemy, że tak i dołożymy starań, żebyś wkrótce mógł z niej skorzystać
            {' '}
            <span role="img" aria-label="emoji">😊</span>
        </Typo.Body>
        <Modal.Footer>
            <Button.Primary onClick={onClick}>
                Zamknij
            </Button.Primary>
        </Modal.Footer>
    </>
);

Step2.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default Step2;
